"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.planSettlement = planSettlement;
const money_1 = require("../money");
/**
 * تخطيط تخصيص تسوية (تحصيل من عميل أو سداد لمورد) على مستندات الطرف المفتوحة.
 * لا تخصيص على مستند طرف آخر، ولا فوق متبقيه، ولا مجموع فوق مبلغ التسوية، ولا مستند
 * مرتين — قاعدة 7 فى عقود البيانات. كل المشاكل تُجمع مرة واحدة بفهرس التخصيص.
 *
 * التخصيص صريح من المتصل؛ «الأقدم أولاً» اقتراح فى الواجهة لا قاعدة هنا، لأن ترتيب
 * السداد اتفاق بين الطرفين لا افتراض محاسبى.
 */
function planSettlement(partyId, amount, requests, openDocuments) {
    const issues = [];
    const total = money_1.Money.of(amount);
    if (!total.isPositive()) {
        issues.push({ code: 'AMOUNT_NOT_POSITIVE', message: 'settlement amount must be positive' });
    }
    const openById = new Map(openDocuments.map((document) => [document.documentId, document]));
    const seen = new Set();
    const allocations = [];
    requests.forEach((request, lineIndex) => {
        const value = money_1.Money.of(request.amount);
        const document = openById.get(request.documentId);
        if (seen.has(request.documentId)) {
            issues.push({
                code: 'ALLOCATION_DUPLICATE_DOCUMENT',
                message: 'document ' + request.documentId + ' is allocated twice',
                lineIndex,
            });
        }
        seen.add(request.documentId);
        if (!value.isPositive()) {
            issues.push({
                code: 'ALLOCATION_NOT_POSITIVE',
                message: 'allocation must be positive',
                lineIndex,
            });
        }
        if (!document) {
            issues.push({
                code: 'ALLOCATION_DOCUMENT_UNKNOWN',
                message: 'document ' + request.documentId + ' is not an open document of this company',
                lineIndex,
            });
        }
        else if (document.partyId !== partyId) {
            issues.push({
                code: 'ALLOCATION_WRONG_PARTY',
                message: 'document belongs to another party',
                lineIndex,
            });
        }
        else if (value.gt(document.openBalance)) {
            issues.push({
                code: 'ALLOCATION_EXCEEDS_OPEN',
                message: 'allocation exceeds the open balance of the document',
                lineIndex,
                details: { openBalance: money_1.Money.of(document.openBalance).toString() },
            });
        }
        allocations.push({ documentId: request.documentId, amount: value });
    });
    const allocated = money_1.Money.sum(allocations.map((allocation) => allocation.amount));
    if (allocated.gt(total)) {
        issues.push({
            code: 'ALLOCATION_EXCEEDS_AMOUNT',
            message: 'allocations total ' + allocated.toString() + ' exceeds the settlement amount',
        });
    }
    if (issues.length > 0)
        return { ok: false, issues };
    return { ok: true, value: { allocations, allocated, unallocated: total.sub(allocated) } };
}
//# sourceMappingURL=settlement.js.map